<!-- 周期作业统计 -->
<template>
    <div class="second_box">
        <el-dialog title="作业统计" :visible.sync="dialogFormVisible" width="70%">

            <el-row :gutter="20">

                <p class="second_p_box"><el-button type="text" class="el-icon-s-data">成绩总览</el-button></p>

                <el-col :span="4">
                    <div>
                    <el-statistic title="完成情况">
                        <template slot="formatter">
                            {{ statistics_data.total_number }}
                        </template>
                    </el-statistic>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div>
                    <el-statistic title="阅读在线数量">
                        <template slot="formatter">
                            {{ statistics_data.read_number }}
                        </template>
                    </el-statistic>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div>
                        <el-statistic title="应试英语数量">
                            <template slot="formatter">
                                {{ statistics_data.specialty_number }}
                            </template>
                        </el-statistic>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div>
                        <el-statistic title="阅读在线正确率">
                            <template slot="formatter">
                                {{ statistics_data.read_average_score }}
                            </template>
                        </el-statistic>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div>
                        <el-statistic title="应试英语正确率">
                            <template slot="formatter">
                                {{ statistics_data.specialty_average_score }}
                            </template>
                        </el-statistic>
                    </div>
                </el-col>
                <el-col :span="4">
                    <div>
                        <el-statistic title="学习总时长">
                            <template slot="formatter">
                                {{ statistics_data.total_time }}
                            </template>
                        </el-statistic>
                    </div>
                </el-col>
            </el-row>

            <el-table
                :data="history_data"
                tooltip-effect="dark"
                style="width: 100%;display: inline-block;margin-top: 30px;"
                >
                <el-table-column
                type="index"
                width="55">
                </el-table-column>
                <el-table-column
                prop="w_id_text"
                label="标题"
                >
                </el-table-column>
                <el-table-column
                prop="table_type_text"
                label="类别"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="score"
                label="正确率"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="time"
                label="耗时"
                width="100"
                >
                </el-table-column>
                <el-table-column
                prop="createtime"
                label="时间"
                width="120"
                >
                </el-table-column>

            </el-table>
        
        </el-dialog>
        
    </div>
</template>
<script>
import Http from "../src/apis/student";
export default {
    data(){
        return{
            dialogFormVisible:false,
            form:{
                plan_id:'',
                task_id:'',
                type:2
            },
            page:1,
            pageSize:20,
            plan_id:'',
            task_id:'',
            statistics_data:{},
            history_data:[],
            total_number:0
        }
    },

    methods:{
  

        // 下方学生列表
        getBottomStudent(){
            var params = this.form
            params.page = this.page
            params.pageSize = this.pageSize
            Http.historyList(params).then((res) => {
                this.history_data = res.data.list
                this.total_number = res.data.total_number
                //this.$emit('hideLoading',false)
            });
        },
     
        // 顶部
        viewWorkDetail(plan_id,task_id){

            this.form.plan_id = plan_id
            this.form.task_id = task_id
            var params = this.form
            Http.workResult(params).then((res) => {
                this.getBottomStudent()
                this.statistics_data = res.data
                this.dialogFormVisible = true
            });
            
        },
 
    }
}
</script>
<style scoped>
.box-card{
    padding: 10px 35px;
    margin-top: 20px;
    margin-right: 15px;
}
.box-card  >>> .el-card__body{

    padding: 0;
}
.box-card .item{
    line-height: 30px;

}

.box-card .number{
    font-weight: 700;
    color: #409EFF;
}
.box-card >>> .name{
    font-weight: 0 !important;
    font-size: 14px;
    font-weight: 700;
}
.box-card span{
    width: auto;
}
.second_box {
    text-align: left;
}

.second_box >>> .el-select{
    width: 25vw;
}
.second_box >>> .el-row{

    margin-top: 15px !important;
    padding: 10px 0;
}
.second_box >>> .title{
 
    line-height: 30px;
 
}
.second_box >>> .number{
 
    line-height: 30px;
    color: #409EFF;
}

.second_box >>> .head{
 
 color: #000000;
}
.second_p_box >>> .el-button--text{

    font-size: 18px;
}
.second_p_box{
    text-indent: 2vw;
    margin: 0 !important;
    padding: 0 !important;
}
.label_button_box{
    width: 100%;
    height: 2vw;
    line-height: 2vw;
    display: inline-block;
    margin-bottom: 20px;
    margin-top:20px;
}
.label_button_box_left{
    float: left;
}
.label_button_box_right{
    float: right;

}
.label_button_box_right >>> .el-button{
        float: right;
    }
.label_button_box_left >>> .el-input{
    float: left;
    width: 15vw;
    margin-right: 10px;
}
.colm_box{
    display: inline-block;
    text-align: right;
    height: 2vw;
    margin-bottom: 20px;
    border: 1px solid rgb(235, 238, 245);
    padding: 0px 20px;
    border-radius: 5px;
    width: 100%;
    box-sizing: border-box;
}
</style>